module.exports = __webpack_public_path__ + "h5/img/master_18.aa0b2b79.jpg";